// hooks/useFetchDomainDetails.ts
"use client"
import { useEffect, useState } from "react";

interface DomainData {
  name: string;
  maincat: string;
  pricing: Record<string, unknown>;
}

interface Domain {
  domainName : string,
  name: string;
  domains: DomainData[]
}

interface DomainPricingParams {
  currency: number;
  country?: string;
  category?: string;
  ext?: string;
  getprice: boolean;
}

const useFetchDomainDetails = (domainName: string | undefined) => {
  const [domainDetails, setDomainDetails] = useState<Domain | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!domainName) return;

    const fetchDomainDetails = async () => {
      setLoading(true);
      setError(null); // Reset error state
      try {
          const arr = domainName.split("-");
          let country = arr[0];
          let domain = arr[1];
        
          if (country) {
            country = country.replace(/_/g, " ");
          }
        
          const countrynames: string[] = [];
        
          let params: DomainPricingParams = {
            currency: 1,
            getprice: true,
          };
        
          if (country) {
            countrynames.push(country);
        
            if (country.toLowerCase() === "timor") {
              domain = ".tl";
            }
        
            params = {
              ...params,
              country: countrynames[0],
              category: countrynames[0],
              ext: domain,
            };
          }
          
        const response = await fetch('/api/domains', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params)
        });

        const data = await response.json(); 
        const domains = data.domains;
        const doms = {
            domainName: domainName,
            name : domain,
            domains : domains
        }
        setDomainDetails(doms);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchDomainDetails();
  }, [domainName]);

  return { domainDetails, loading, error };
};

export default useFetchDomainDetails;
